import React from 'react';
import { Event } from '../Event.interface';
import { Link } from 'react-router-dom';
import './EventPreview.css'

const EventPreview = (props: { event: Event, past?: boolean }) => {

  function makeEventName() {
    const event = props.event;
    let renderName = event.name || 'Doktor Triceratops';
    if (!event.name && (event.place || event.location)) {
      if (event.place && event.location) {
        renderName += ` - ${event.place} (${event.location})`;
      } else {
        renderName += ' - ' + (event.place || event.location);
      }
    }
    return renderName;
  }

  const months = [
    "Leden", "Únor", "Březen",
    "Duben", "Květen", "Červen",
    "Červenec", "Srpen", "Září",
    "Říjen", "Listopad", "Prosinec"
  ];
  const event = props.event;
  const renderMonth = months[event.month - 1]; // 1 from human input = Leden
  const renderName = makeEventName().replace(/&quot;/g, '"').replace(/&apos;/g, '\'');
  const linkName = renderName.normalize('NFKD').replace(/[\u0300-\u036f]/g, "").replace(/[^\w]/g, '-');

  return (
    <div className="event-preview">
      <Link to={`/akce/${event.year}/${event.month}/${event.day}/${linkName}`}>
        <div className="event-preview-date">
          <div className={"event-month" + (props.past ? " event-date-past" : "")}>{renderMonth}</div>
          <div className={"event-day" + (props.past ? " event-date-past" : "")}>{event.day}</div>
          <div className={"event-year" + (props.past ? " event-date-past" : "")}>{event.year}</div>
        </div>
        <div className="event-preview-details">
          <div className="event-preview-name">
            {renderName}
          </div>
          <div className="event-preview-time">
            {event.weekday || ''} {event.time && event.time !== '0:00 hod' && event.time !== '00:00 hod' ? event.time : ''}
          </div>
        </div>
        <div className="event-preview-location">
          <div className="event-preview-place">
            {(event.place || '').replace(/&quot;/g, '"').replace(/&apos;/g, '\'')}
          </div>
          <div className="event-preview-area">
            {(event.location || '').replace(/&quot;/g, '"').replace(/&apos;/g, '\'')}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default EventPreview;